var map = {
	"./american express.png": "915f",
	"./bank.png": "1f59",
	"./card.png": "013a",
	"./cash.png": "4958",
	"./crypto.png": "dd14",
	"./diners club.png": "a05e",
	"./master card.png": "8209",
	"./visa.png": "cbab",
	"./wallet.png": "34bb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b222";